<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="companyList$ | async as compList">
				<ng-container *ngIf="compList.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ng-container *ngIf="!compList.isSkeleton">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid
								(onOptionChanged)="handlePropertyChange($event)"
								id="gridContainer"
								[dataSource]="compList.data.data"
								keyExpr="id"
								[allowColumnResizing]="true"
								[columnAutoWidth]="true"
								[showBorders]="true"
							>
								<dxo-search-panel
									[visible]="true"
									[width]="240"
									placeholder="Search..."
								></dxo-search-panel>
								<dxo-header-filter
									[visible]="showHeaderFilter"
								></dxo-header-filter>
								<dxo-column-chooser
									[enabled]="true"
									mode="select"
								></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column
									caption="Actions"
									dataField="id"
									[allowFiltering]="false"
									[allowSorting]="false"
									cellTemplate="cellTemplate"
									[width]="150"
								>
								</dxi-column>

								<dxi-column
									dataField="name"
									caption="Name"
									[width]="230"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="email"
									caption="Email"
									[width]="230"
									[visible]="false"
								></dxi-column>

								<dxi-column
									dataField="url"
									caption="Url"
									[width]="230"
									[visible]="true"
								></dxi-column>
								<dxi-column
									dataField="responseStatus"
									caption="Response Status"
									[width]="230"
									[visible]="false"
								></dxi-column>
								<dxi-column
									cellTemplate="cellTemplateLogo"
									dataField=""
									caption="Logo"
								></dxi-column>
								<div
									*dxTemplate="let d of 'cellTemplateLogo'"
									class="text-center"
								>
									<img [src]="d.data.logoUrl" class="logoUrl" />
								</div>

								<div *dxTemplate="let d of 'cellTemplate'">
									<a
										class="cursor"
										(click)="viewMails(d.data.members, d.data.id)"
										>Manage Mail</a
									>
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Company Mails</p>
										</div>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ng-container>
			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>
